import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { inject } from 'mobx-react';
import Edit from '@material-ui/icons/Edit'
import Add from '@material-ui/icons/Add'
import Remove from '@material-ui/icons/Remove'
import Save from '@material-ui/icons/Save'
import Share from '@material-ui/icons/Share'
import { Link } from 'react-router-dom'

const styles = theme => ({
});

@inject('videoStore')
class Header extends Component {
  handleEdit = () => {
    console.log('Edit clicked')
  }

  handleSave = () => {
    console.log('Save/Share clicked')
  }

  handleShare = () => {
    console.log('Share clicked')
  }

  render = () => {
    const store = this.props.videoStore
  
    return (
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h5">Video Wall</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Button size="small" onClick={store.handleAddOpen} variant="contained" color="secondary"><Add /></Button>
          {
          //<Button size="small" onClick={store.handleRemove} variant="contained" color="secondary"><Remove /></Button>
          }
        </Toolbar>
      </AppBar>
    );
  }
}

export default withStyles(styles)(Header)


// WEBPACK FOOTER //
// ./src/components/Header.js